import { render, staticRenderFns } from "./epmsb200.vue?vue&type=template&id=72a10884&scoped=true"
import script from "./epmsb200.vue?vue&type=script&lang=js"
export * from "./epmsb200.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a10884",
  null
  
)

export default component.exports